import React from "react";
import "../redeem.css";

const SUPPORT_URL = "https://support.verysoul.com/portal/en/newticket";

export function Check() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

// Page frame for the public gift pages (/redeem, /gift-pay/*): VerySoul
// header with tagline, optional step indicator, support footer.
// `steps` + `step`: the indicator shows from the second step onwards.
export default function GiftShell({ steps, step, children, floating }) {
  const current = steps ? steps.findIndex((item) => item.key === step) : -1;
  return (
    <div className={`vsr-page ${floating ? "has-floating-bar" : ""}`}>
      <header className="vsr-header">
        <img src="/images/logo-verysoul.png" alt="VerySoul" className="vsr-logo" />
        <p className="vsr-tagline">
          <span>Evidence.</span>
          <i aria-hidden="true" />
          <span>Inspiration.</span>
          <i aria-hidden="true" />
          <span>Empowerment.</span>
        </p>
      </header>
      {current > 0 && (
        <nav className="vsr-steps" aria-label="Booking steps">
          <ol>
            {steps.map((item, index) => (
              <li
                key={item.key}
                className={index < current ? "is-done" : index === current ? "is-current" : ""}
                aria-current={index === current ? "step" : undefined}
              >
                <span className="vsr-step-dot">{index < current ? <Check /> : index + 1}</span>
                {item.label}
              </li>
            ))}
          </ol>
        </nav>
      )}
      <main className="vsr-main">{children}</main>
      <footer className="vsr-footer">
        Have a question?{" "}
        <a href={SUPPORT_URL} target="_blank" rel="noopener noreferrer">
          Submit Support Ticket
        </a>
      </footer>
    </div>
  );
}
